import { render } from "./openImage.vue?vue&type=template&id=4e6bd1fa&scoped=true"
import script from "./openImage.vue?vue&type=script&lang=js"
export * from "./openImage.vue?vue&type=script&lang=js"

import "./openImage.vue?vue&type=style&index=0&id=4e6bd1fa&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6bd1fa"]])

export default __exports__